import supabaseClient from '@/api/supabaseClient.ts';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { FunctionsHttpError } from '@supabase/supabase-js';
import { BackendErrorResponse } from '@/types/response/BackendErrorResponse';

export type CreateReviewParams = {
  booking_id?: string;
  intro_call_id?: string;
  reviewee_id: string;
  rating: number;
  comment?: string;
};

const useCreateReview = () => {
  const queryClient = useQueryClient();

  const mutationFn = async (params: CreateReviewParams) => {
    const { data, error } = await supabaseClient.functions.invoke('create_review', {
      method: 'POST',
      body: params,
    });

    if (error) {
      if (error instanceof FunctionsHttpError) {
        const err: BackendErrorResponse = await error.context.json();
        throw new Error(err.errors.join(', '));
      }
      throw new Error((error as Error).message);
    }

    return data;
  };

  return useMutation({
    mutationFn,
    onSuccess: () => {
      // Invalidate queries to refetch with updated review status
      queryClient.invalidateQueries({ queryKey: ['bookingRequests'] });
      queryClient.invalidateQueries({ queryKey: ['introCallRequests'] });
    },
  });
};

export default useCreateReview;
